

<template>


  <div class="container-fluid p-0">
    <!-- 1. Hero Section - Carousel -->
    <div id="heroCarousel" class="carousel slide  w-80" data-bs-ride="carousel">
      <div class="carousel-inner">
         <!-- Slide 1 -->
        <div class="carousel-item active">
        <div class="carousel-image bg-image-1 d-flex align-items-center justify-content-center text-white text-center">
      
      </div>
    </div> 

     <!-- Slide 2 -->
    <div class="carousel-item">
      <div class="carousel-image bg-image-2 d-flex align-items-center justify-content-center text-white text-center">
        <div class="bg-dark bg-opacity-50 p-4 rounded">
          <h1 class="display-6">Start Your Learning Journey</h1>
          <p class="fs-5">Build skills in critical & computational thinking, and real-world projects</p>
        </div>
      </div>
    </div>


    </div>
      
   
      <button class="carousel-control-prev" type="button" data-bs-target="#heroCarousel" data-bs-slide="prev">
        <span class="carousel-control-prev-icon"></span>
      </button>
      <button class="carousel-control-next" type="button" data-bs-target="#heroCarousel" data-bs-slide="next">
        <span class="carousel-control-next-icon"></span>
      </button>
    </div>
</div>
<br><br><br>
<BaseContainer>
  <section class="mb-5">
<div class="row justify-content-center align-items-stretch g-3">
    <!-- Image -->
      
  <div class="col-12 col-md-5">
   <ShadowCardHighlight :object="{id:2,title: 'Go Beyond the Basics, and Turn Curiosity into Capability.',
description:  `Encouraging learners to look beyond basic knowledge, explore ideas and develop a deeper understanding of the subjects they study. `}"  >
</ShadowCardHighlight>
</div>
    <!-- Text -->
    
  <div class="col-12 col-md-5">
     <img
      :src="books"
      alt="Academy"
      class="normal-image"
      >
   
     
    </div>
   
  </div>

</section>
 <section class="mb-5">
 <h1 class="display-6 text-center text-success mb-4">Learning Pathways</h1>
  <div class="row align-items-center">
    
    <!-- Image -->
      <div class="col-md-4">
        <ShadowCardInfo  :object="{id:2,title: 'Curriculum-Based Learning',
          description:  `We teach through practical projects and experimentation. Students connect theory with technologies to develop computational thinking and problem-solving skills along the way `,
           link: '/learning-pathways'
          
          }"  >
        </ShadowCardInfo>
    </div>
       <div class="col-md-4">
        <ShadowCardInfo  :object="{id:2,title: 'Inquiry-Based Learning',
          description:  `This pathway encourages students to investigates, builds, tests and reflects on the choice of their topic. It runs all year around to build and enhance the lnwoeldhe of the subject. `,
             link: '/learning-pathways'}"  >
        </ShadowCardInfo>
    </div>
       <div class="col-md-4">
        <ShadowCardInfo  :object="{id:2,title: 'Applied Learning',
          description:  `We teach through practical projects and experimentation. Students connect theory with technologies to develop computational thinking and problem-solving skills along the way `,
             link: '/learning-pathways'}"  >
        </ShadowCardInfo>
    </div>



  </div>
</section>


 <section class="mb-5">
<div class="row justify-content-center align-items-stretch g-3">
                 <!-- Image -->
    <div class="col-12 col-md-5">
     <img
      :src="tutoring"
      alt="Academy"
      class="normal-image"
      >
    </div>
       <div class="col-12 col-md-5">
       <ShadowCardInfo  :object="{id:2,title: 'Transformed Online Tutoring',
description:  `We go beyond simply working through the prescribed syllabus or set content. Our online tutoring uses the <b>tutor's experience, observations and exposure to real-world contexts</b>, disciplines and scenarios to help students connect academic concepts with how they are used in practice.
`,
             image: tutoring,
             link: '/online-tutoring'  ,

             
             
             }"  
             
             >

</ShadowCardInfo>
    </div>
  



  </div>
</section>
 <section class="mb-5">
   <div class="row align-items-center">
     <div class="col-md-4">
<ShadowCardInfo  :object="{id:2,title: 'Develop Transferable Skills',
description:  `We help students develop <b>critical thinking, computational thinking, and problem-solving skills</b> by recognising and applying cognitive tools such as <b>abstraction, modularisation, and object orientation</b>.
<b>This approach can be applied across different subjects</b> not only in Computer Science, but also to Mathematics, Physics, Biology, Chemistry, Engineering, and other academic subjects.`,
             image: transferable_skills,
               link: '/transferable-skills'  
             }">
           
             

 <template #image="{ object }">
    <img
      v-if="object.image"
      :src="object.image"
      style="max-width: 100%; height: 100%;"
    />
  </template>
</ShadowCardInfo>
</div>
    <div class="col-md-4">
<ShadowCardInfo  :object="{id:2,title: 'Think on the paper',
description:  `We encourage students to “think on the paper” — using writing, diagrams, calculations, examples, questions and partial attempts as part of the learning process.
<b>To externalise their thinking and use writing as a tool for understanding</b>. By writing explanations, asking questions, making predictions, attempting solutions and correcting mistakes, students actively build and refine their knowledge. `,
             image: think_on_paper,
               link: '/'  }"  >

 <template #image="{ object }">
    <img
      v-if="object.image"
      :src="object.image"
      style="max-width: 100%; height: 100%;"
    />
  </template>
</ShadowCardInfo>
 
</div>
   <div class="col-md-4">
<ShadowCardInfo  :object="{id:2,title: 'Our Interactive Teaching Approach',
description:  `We know you want the best for yourself — and so do we. Our experienced teachers help students <b>build confidence, and re-discover the learning they can enjoy and relate to</b>.
            <p>Our friendly teachers make tough topics click—and your confidence soar. Whether you're aiming for top grades or just trying to keep up, we’ve got your back.</p> `,
             image: teaching_approach,
               link: '/teaching'  
             
             }"  >

 <template #image="{ object }">
    <img
      v-if="object.image"
      :src="object.image"
      style="max-width: 100%; height: 100%;"
    />
  </template>
</ShadowCardInfo>
 
</div>



</div>

</section>


    <!-- 2. Quick Overview of Offerings -->
 

    <!-- 4. Testimonials -->
    <section class="container my-5">
      <h2 class="text-center display-6">Student Testimonials</h2>
      <div class="row justify-content-center">
        <div class="col-md-8">
          <div class="bg-light card p-4 text-center">
            <blockquote class="blockquote mb-0">
              <p>"Helped me improve my general and in-depth knowledge regarding to pseudocode and python..."</p>
              <footer class="blockquote-footer mt-2">iGCSE Student</footer>
            </blockquote>
            <div class="text-center mt-3">
            <a href="/testimonials" class="btn btn-outline-success mt-3">Read more</a>
          </div>
          </div>
          
        </div>
      </div>
    </section>

    <!-- 5. Call to Action / Jumbotron -->
    <section class="bg-success text-white py-5">
      <div class="text-center">
        <h4>Ready to Take the Next Step?</h4>
        <p class="lead">Whether you're preparing for GCSEs, A-level or exploring IB options, we're here to help you succeed.</p>
        <router-link to="/contact" class="btn btn-light mt-3 contact-button">Contact Us</router-link>
      </div>
    </section>


</BaseContainer>
 
</template>


<script setup>

import tutoring from '@/assets/images/home_page/other/photo-tutoring-121.avif'
import books from '@/assets/images/home_page/other/susan-unsplash-1.jpg'
import think_on_paper from '@/assets/images/home_page/other/think_on_paper_2.jpg'
import teaching_approach from '@/assets/images/home_page/other/teaching_approach.svg'
import transferable_skills from '@/assets/images/home_page/other/transferable-skills.svg'

</script>
<script>

import BaseContainer  from '@/components/BaseContainer.vue';
import ShadowCardInfo from '@/components/ShadowCardInfo.vue';
import ShadowCardHighlight from '@/components/ShadowCardHighlight.vue';
//import BlockHorizontalTextNoBorder from '@/components/BlockHorizontalTextNoBorder.vue';
export default {
  name: 'HomePage',
  components: {
      BaseContainer,ShadowCardInfo,ShadowCardHighlight,
  },
  data() {
    return {
      offerings: [
        {
          title: 'Digital Ecosystem',
          description: 'Building computational thinking at the system level — and that’s where real-world tech innovation happens...!',
          link: '/digital-learning-ecosystem'
        },
        {
          title: 'Constructing & Cultivating Computational thinking',
          description: 'GCSE/iGCSE, A-Level & IB  ',
          link: '/computational-thinking'
        },
        {
          title: 'Artifical Intelligence',
          description: 'Understand and apply the core concepts, algorithms...',
          link: '/artificial-intelligence'
        }
      ],
      strengths: [
        {
          title: 'Qualified Tutors',
          text: 'Every tutor is certified and experienced.',
          icon: 'bi bi-person-check'
        },
        {
          title: 'Flexible Sessions',
          text: 'Evening & weekend availability.',
          icon: 'bi bi-clock-history'
        },
        {
          title: 'Online + In-person',
          text: 'Join from anywhere or visit us locally.',
          icon: 'bi bi-laptop'
        },
        {
          title: 'Progress Tracking',
          text: 'Regular updates & parent feedback.',
          icon: 'bi bi-graph-up-arrow'
        }
      ]
    };
  }
};

</script>

<style scoped>
.carousel img {
  //max-height: 300px;
  //object-fit: cover;
}
.carousel {
  /*border: 2px solid black; /* change to any color */
  /*border-radius: 10px;     /* optional: adds rounded corners */
}
.carousel.custom-border {
  //border: 1px solid darkgray;
}
.carousel-control-prev-icon,
.carousel-control-next-icon {
  filter: invert(1) brightness(0.3); /* Makes arrow dark */
  /* background-color: rgba(255, 255, 255, 0.6); Optional: adds light background */
 /*  //border-radius: 50%; Optional: round background */
}

.bg-pale-green {
  background-color: lightgray;
  color: black;
}

.offering-card-title {
 
  color: darkgreen;
}
.offering-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
}


.feature-box {
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}
.feature-box:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.05);
}
.why-section {
  background-color:  #f8f9fa; /* Very light gray *//* Very light gray */
  /* border-top: 1px solid #dce1e5;*/
}

.contact-button {
  background-color: white;
  color: green;
}

.feature-title {
  font-weight: 600;
  color: #222;
}

.feature-description {
  color: #555;
  font-size: 0.95rem;
}

/* Below CSS is for the logo StepEdge Academy */
.logo-container {
  font-family: 'Poppins', sans-serif;
}

.step-edge {
  font-size: 1.5rem;
  color: #33691e; /* dark green */
  position: relative;
}

.first-letter {
  font-size: 1.75rem;
  font-weight: 500;
}

.academy {
  font-size: 1.2rem;
  color: #66bb6a; /* light green */
  letter-spacing: 0.3rem;
  margin-top: 0.5rem;
}

/* Line Step Effect */
.line-step {
  position: absolute;
  left: 2.7rem; /* adjust depending on font size */
  top: -0.8rem;
  width: 3.5rem;
  height: 3rem;
  border-left: 2px solid #66bb6a;
  border-top: 2px solid #66bb6a;
  border-bottom: 2px solid #66bb6a;
  border-right: none;
  transform: rotate(0deg);
}

/* END CSS for the logo StepEdge Academy */


.carousel-image {
  height: 60vh;
  background-size: 100%;
  background-position: center 45%;
  background-repeat: no-repeat;
}



@media (max-width: 768px) {
  .carousel-image {
    height: 40vh;
    background-size: 150%;
    background-position: center 52% 45%;
  }
}



.bg-image-1 {
  background-image: url('@/assets/images/home_page/slider/stepedge_main_10.svg'); /* Replace with your image susan-unsplash-2.jpg */
}
.bg-image-2 {
  background-image: url('@/assets/images/home_page/slider/park_table_1.jpg'); /* Change to your image  photo-tutoring-121.avif*/
}

/*
.my-section {
  width: 500px;
  height: 300px;
  background-image: url('@/assets/images/learning_pathways_1.jpg');
  background-size: cover;
  background-position: center;
}*/
.normal-image {
  display: block;
  max-width: 100%;
  height: auto;
  margin-inline: auto;
}


</style>
